__turbopack_context__.v({
  "label": "OwnerBanner-module-scss-module__g1jbMa__label",
  "link": "OwnerBanner-module-scss-module__g1jbMa__link",
  "root": "OwnerBanner-module-scss-module__g1jbMa__root",
  "slideIn": "OwnerBanner-module-scss-module__g1jbMa__slideIn",
  "spin": "OwnerBanner-module-scss-module__g1jbMa__spin",
  "spinner": "OwnerBanner-module-scss-module__g1jbMa__spinner",
});
